import React from "react";

import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import GroupIcon from "@mui/icons-material/Group";
import LoginIcon from "@mui/icons-material/Login";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Box from "@mui/material/Box";
import logoNavbar from "../../assets/img/logoNavbar.jpeg";

import { useSelector } from "react-redux";

import {
	selectIsAdmin,
	selectPermissaoCadastrar,
	selectIsAuthenticated,
} from "../../storeConfig/reducers/loginReducer";

function NavBarDesktop({ logout }) {
	const isAdmin = useSelector(selectIsAdmin);
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const PermissaoCadastrar = useSelector(selectPermissaoCadastrar);

	return (
		<>
			{/* Logo Desktop */}
			<Box
				noWrap
				sx={{
					mr: 2,
					display: { xs: "none", md: "flex" },
					fontFamily: "monospace",
					fontWeight: 700,
					letterSpacing: ".3rem",
					color: "primary",
					textDecoration: "none",
				}}
			>
				<Link to="/" className="navbar-brand justify-content-center">
					<img
						className="image-fluid"
						width="100px"
						src={logoNavbar}
						alt="Logo do SGIO"
					/>
				</Link>
			</Box>

			{/* Menu Desktop  */}
			<Box
				sx={{
					flexGrow: 1,
					display: { xs: "none", md: "flex" },
				}}
			>
				{isAuthenticated && (
					<Link to="/form" className="text-decoration-none mx-2">
						<Button>Calcular</Button>
					</Link>
				)}

				{!isAuthenticated && (
					<Link to="/login" className="text-decoration-none mx-2">
						<Button startIcon={<LoginIcon />}>Login</Button>
					</Link>
				)}

				{!isAuthenticated && (
					<Link
						to="/cadastre-se"
						className="text-decoration-none mx-2"
					>
						<Button startIcon={<HowToRegIcon />}>
							Cadastre-se
						</Button>
					</Link>
				)}

				{isAuthenticated && (
					<Link className="text-decoration-none mx-2" to="/perfil">
						<Button startIcon={<AccountCircleIcon />}>
							Perfil
						</Button>
					</Link>
				)}

				{isAuthenticated && (
					<Link
						className="text-decoration-none mx-2"
						to="/meus-resultados"
					>
						<Button startIcon={<AssessmentIcon />}>
							Resultados
						</Button>
					</Link>
				)}

				{isAdmin && isAuthenticated && (
					<Link className="text-decoration-none mx-2" to="/admin">
						<Button startIcon={<AdminPanelSettingsIcon />}>
							Administrador
						</Button>
					</Link>
				)}

				{PermissaoCadastrar && isAuthenticated && (
					<Link className="text-decoration-none mx-2" to="/gestor">
						<Button startIcon={<AdminPanelSettingsIcon />}>
							Gestor
						</Button>
					</Link>
				)}

				{isAuthenticated && (
					<Button startIcon={<ExitToAppIcon />} onClick={logout}>
						Sair
					</Button>
				)}

				<Link className="text-decoration-none mx-2" to="/sobre">
					<Button startIcon={<GroupIcon />}>Sobre Nós</Button>
				</Link>
			</Box>
		</>
	);
}

export default NavBarDesktop;
